var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons II"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6666 2.66667C12.6666 1.95942 12.3856 1.28115 11.8855 0.781049C11.3854 0.280952 10.7072 0 9.99992 0H5.99992C5.29267 0 4.6144 0.280952 4.1143 0.781049C3.6142 1.28115 3.33325 1.95942 3.33325 2.66667V3.33333H12.6666V2.66667ZM10.6666 10H5.33325C4.22868 10 3.33325 10.8954 3.33325 12V14C3.33325 15.1046 4.22868 16 5.33325 16H10.6666C11.7712 16 12.6666 15.1046 12.6666 14V12C12.6666 10.8954 11.7712 10 10.6666 10ZM3.33333 4.66667H12.6667C13.5504 4.66773 14.3976 5.01926 15.0225 5.64415C15.6474 6.26904 15.9989 7.11628 16 8V10.6667C15.9991 11.3145 15.8095 11.9481 15.4543 12.4899C15.0991 13.0317 14.5938 13.4582 14 13.7173V12C13.9989 11.1163 13.6474 10.269 13.0225 9.64415C12.3976 9.01926 11.5504 8.66773 10.6667 8.66667H5.33333C4.4496 8.66773 3.60237 9.01926 2.97748 9.64415C2.35259 10.269 2.00106 11.1163 2 12V13.7173C1.40624 13.4582 0.900862 13.0317 0.545666 12.4899C0.19047 11.9481 0.00085225 11.3145 0 10.6667V8C0.00105857 7.11628 0.352588 6.26904 0.97748 5.64415C1.60237 5.01926 2.4496 4.66773 3.33333 4.66667ZM10.6667 7.33334H12C12.1768 7.33334 12.3464 7.2631 12.4714 7.13808C12.5964 7.01305 12.6667 6.84348 12.6667 6.66667C12.6667 6.48986 12.5964 6.32029 12.4714 6.19527C12.3464 6.07024 12.1768 6.00001 12 6.00001H10.6667C10.4899 6.00001 10.3203 6.07024 10.1953 6.19527C10.0702 6.32029 10 6.48986 10 6.66667C10 6.84348 10.0702 7.01305 10.1953 7.13808C10.3203 7.2631 10.4899 7.33334 10.6667 7.33334Z",
    fill: "#FF3131"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.ef5780d3fe9775004eb85962d06b3c5d.svg";
export { ForwardRef as ReactComponent };